import React from 'react';
import { RecentTicket } from '../callCenterDashboardTypes';
import { PriorityBadge, StatusBadge } from '../../shared';
import styles from './RecentTicketsCard.module.css';

interface RecentTicketsCardProps {
  tickets: RecentTicket[];
  onViewAll?: () => void;
}

export const RecentTicketsCard: React.FC<RecentTicketsCardProps> = ({
  tickets,
  onViewAll,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          <span className={styles.headerIcon}>📋</span> Recent Tickets
        </h3>
        <button className={styles.viewAll} onClick={onViewAll}>
          View All
        </button>
      </div>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>TICKET</th>
              <th>MODULE</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((t) => (
              <tr key={t.id}>
                <td>
                  <p className={styles.ticketId}>{t.ticketId}</p>
                  <p className={styles.customer}>{t.customer}</p>
                </td>
                <td>{t.module}</td>
                <td>
                  <PriorityBadge priority={t.priority} />
                </td>
                <td>
                  <StatusBadge status={t.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
